module.exports = __webpack_public_path__ + "img/logo_launch_mitre.664861e2.svg";